import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { ProtocoloAssuntoService } from '../protocolo-assunto/protocolo-assunto.service';

@Component({
  selector: 'ntc-protocolo-motivo',
  templateUrl: './protocolo-motivo.component.html',
  styleUrls: ['./protocolo-motivo.component.css']
})
export class ProtocoloMotivoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridProtocoloMotivo = null;
  protocoloMotivo = null;
  alturaGrid = null;
  listaProtocoloAssunto = [];

  editOptionsGridProtocoloMotivo = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Protocolo Motivo',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private protocoloAssuntoService: ProtocoloAssuntoService,
  ) {
    this.protocoloMotivo = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/protocolo-motivo/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/protocolo-motivo/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/protocolo-motivo/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/protocolo-motivo/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  montaColunasGrid = function (){
    this.colunasGridProtocoloMotivo = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'IdProtocoloAssunto',
        dataType: 'string',
        caption: 'Assunto do Protocolo',
        validationRules: [{
          type: 'required',
          message: 'Assunto do Protocolo é obrigatório.'
        }],
        lookup: {
          dataSource: this.listaProtocoloAssunto,
          displayExpr: 'DescricaoProtocoloAssunto',
          valueExpr: 'Id'
        }
      },
      {
        dataField: 'DescricaoProtocoloMotivo',
        dataType: 'string',
        caption: 'Descrição',
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatória.'
        }]
      }
    ];
  };

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();

    this.protocoloAssuntoService.getProtocoloAssuntos().subscribe(protocoloAssuntos => {
      this.listaProtocoloAssunto = protocoloAssuntos;
      this.montaColunasGrid();
    }, error => {
      this.montaColunasGrid();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/protocolo-motivo/protocolo-motivo.component.ts